import { type RootState } from '../../../store';

export const childrenSelector = (state: RootState) => state.children;
